// Source https://github.com/marcuswestin/store.js#make-your-own-build
import engine from 'store/src/store-engine';
import localStorage from 'store/storages/localStorage';
import sessionStorage from 'store/storages/sessionStorage';

export const SEARCH_SCROLL_KEY = 'tock_searchScrollOffset';

interface SearchScrollOffset {
  type: 'offset';
  key: string;
  scrollOffset: number;
}

interface SearchScrollBusinessId {
  type: 'businessId';
  key: string;
  selectedBusinessId: number;
}

export type SearchScrollValue = SearchScrollBusinessId | SearchScrollOffset;

export const sessionPrioritizedBackend = engine.createStore(
  [sessionStorage, localStorage],
  [] // no plugins
);
export const localPrioritizedBackend = engine.createStore(
  [localStorage, sessionStorage],
  [] // no plugins
);
